import {convertCoordinates} from '@/api/util-coordinates';

class MountainPortApiResponseModel {
  // #region Props

  // #endregion
  constructor(
    {
      id,
      name,
      highway,
      province,
      region,
      category,
      height,
      c1,
      c2,
      c3,
      cx,
      cy,
      // visible,
    },
    locale = 'es-ES',
  ) {
    const heightNumberFormat = new Intl.NumberFormat(locale, {
      style: 'decimal',
      maximumFractionDigits: 0,
    });
    return {
      id,
      name,
      highway,
      province,
      region,
      category,
      height: heightNumberFormat.format(height),
      c1,
      c2,
      c3,
      coordinates: convertCoordinates(cx, cy),
      visible: false,
    };
  }
}

export default MountainPortApiResponseModel;
